import React from "react";
import DiscIcon from '../../../../../images/features-page/integrations/disc.svg';
import HeadPhonesIcon from '../../../../../images/features-page/integrations/headphones.svg';
import IcmIcon from '../../../../../images/features-page/integrations/icm.svg';
import PhoneOutgoingIcon from '../../../../../images/features-page/integrations/phone-outgoing.svg';
import UploadCloudIcon from '../../../../../images/features-page/integrations/upload-cloud.svg';
import UserIcon from '../../../../../images/features-page/integrations/user.svg';
import { Styled } from './styled';

const Integrations = () => {
  const integrationItems = ['AlfaCRM', 'ALLOSTAT', 'AmoCRM', 'ApixDrive', 'BrizoCRM', 'Callibri', 'EnvyCRM', 'FITBASE',
    'FreshOffice', 'Get Course', 'HelloClient CRM', 'HOLLIHOP', 'imot.io', 'Leeloo.ai', 'LiveSklad CRM', 'MegaCRM',
    'OneBox', 'Planfix', 'ProducerCRM', 'Ramex', 'Roistat', 'retailCRM', 'S2 CRM', 'SalesMan CRM',
    'SalesMax (Mawisoft)', 'Speech Analytics', 'StorVerk', 'SYNERGY CRM', 'UTMSTAT', 'UseDesk', 'WireCRM', 'YClients',
    'Yeahdesk', 'YUCRM', 'Битрикс 24', 'Клиентская база', 'Мой Склад', 'РемОнлайн'];

  const opportunities = [
    {
      icon: <DiscIcon />,
      text: 'Автосоздание контактов и сделок'
    },
    {
      icon: <UploadCloudIcon />,
      text: (
        <>
          Загрузка звонков <br />
          в карточку клиента
        </>
      )
    },
    {
      icon: <HeadPhonesIcon />,
      text: 'Прослушивание звонков из CRM-системы'
    },
    {
      icon: <IcmIcon />,
      text: 'Распределение звонков на ответственных'
    },
    {
      icon: <PhoneOutgoingIcon />,
      text: (
        <>
          Звонки <br />
          в один клик
        </>
      )
    },
    {
      icon: <UserIcon />,
      text: (
        <>
          Всплывающая <br />
          карточка
        </>
      )
    },
  ]

  return (
    <Styled.Container>
      <Styled.Title>
        Интеграции
      </Styled.Title>
      <Styled.Content>
          {integrationItems.map((item) => (
            <Styled.Text>{item}</Styled.Text>
          ))}
      </Styled.Content>
      <Styled.Link href={'https://onlinepbx.evateam.ru/docs/docs/DOC-000120#integraczii'}>Подробнее об интеграциях →</Styled.Link>
      <Styled.Block>
        <Styled.TitleBlock>
          Основные возможности интеграций
        </Styled.TitleBlock>
        <Styled.WrapperBlock>
          <div>
            {opportunities.slice(0, 3).map((item) => (
              <Styled.Wrapper>
                <Styled.Icon>
                  {item.icon}
                </Styled.Icon>
                <Styled.WrapperText>{item.text}</Styled.WrapperText>
              </Styled.Wrapper>
            ))}
          </div>
          <Styled.Indent/>
          <div>
            {opportunities.slice(3, 7).map((item) => (
              <Styled.Wrapper>
                <Styled.Icon>
                  {item.icon}
                </Styled.Icon>
                <Styled.WrapperText>{item.text}</Styled.WrapperText>
              </Styled.Wrapper>
            ))}
          </div>
        </Styled.WrapperBlock>
      </Styled.Block>
    </Styled.Container>
  )
}

export default Integrations
